// tmp comment
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import getSvg from './getSvg';

const StyledSvg = styled.svg`
  width: ${props => props.s.width || '6.25rem'};
  height: ${props => props.s.height || 'auto'};
  fill: ${props => props.s.fill || '#000'};
  vertical-align: ${props => props.s.verticalAlign || 'initial'};
`;

const Svg = ({ className, s, name }) => (
  <StyledSvg className={className} s={s} data-test={name}>
    <g
      dangerouslySetInnerHTML={{
        __html: getSvg(name),
      }}
    />
  </StyledSvg>
);

Svg.displayName = 'SVG';

Svg.defaultProps = {
  className: null,
  s: {},
  name: null,
};

Svg.propTypes = {
  className: PropTypes.string,
  s: PropTypes.shape({
    width: PropTypes.string,
    height: PropTypes.string,
    fill: PropTypes.string,
    verticalAlign: PropTypes.string,
  }),
  name: PropTypes.string,
};

export default Svg;
